import { all, fork, put, takeEvery, call } from 'redux-saga/effects';
import { SagaIterator } from '@redux-saga/core';

// apicore
import { APICore, setAuthorization } from 'src/helpers/api/apiCore';

// api
import {
    creatNotify as createNotifyApi,
    updateNotify as updateNotifyApi,
    getAllNotify as getAllNotifyApi,
    getNotify as getNotifyApi,
} from './api';

// actions
import { notifyApiResponseSuccess, notifyApiResponseError } from './actions';

// constants
import { NotifyActionTypes } from './constants';

type NotifyData = {
    payload: any;
    type: string;
};

const api = new APICore();

/**
 * Add Notify
 * @param {*} payload
 */
function* AddNotify({ payload, type }: NotifyData): SagaIterator {
    try {
        const response = yield call(createNotifyApi, payload);
        const { data, message, success, code } = response.data;
        if (code === 200 && success) {
            yield put(
                notifyApiResponseSuccess(
                    NotifyActionTypes.ADD_NOTIFY,
                    data,
                    'Notify has been created.',
                    code,
                    false,
                    true
                )
            );
        } else {
            let msg = `An error while creating notify!`;
            if (message) msg = message;
            yield put(notifyApiResponseSuccess(NotifyActionTypes.ADD_NOTIFY, data, msg, code, true, false));
        }
    } catch (error: any) {
        yield put(notifyApiResponseError(NotifyActionTypes.ADD_NOTIFY, [], error, 404, true, false));
    }
}

/**
 * Edit Notify
 * @param {*} payload
 */
function* EditNotify({ payload, type }: NotifyData): SagaIterator {
    try {
        const response = yield call(updateNotifyApi, payload);
        const { data, message, success, code } = response.data;
        if (code === 200 && success) {
            yield put(
                notifyApiResponseSuccess(
                    NotifyActionTypes.EDIT_NOTIFY,
                    data,
                    'Notify Get Updated Successfully',
                    code,
                    false,
                    true
                )
            );
        } else {
            let msg = `An error while edit notify!`;
            if (message) msg = message;
            yield put(notifyApiResponseSuccess(NotifyActionTypes.EDIT_NOTIFY, data, msg, code, true, false));
        }
    } catch (error: any) {
        yield put(notifyApiResponseError(NotifyActionTypes.EDIT_NOTIFY, [], error, 404, true, false));
    }
}

/**
 * Fetch Notify
 * @param {*} payload
 */
function* GetNotify({ payload, type }: NotifyData): SagaIterator {
    try {
        const response = yield call(getNotifyApi, payload);
        const { data, message, success, code } = response.data;
        if (code === 200 && success) {
            yield put(notifyApiResponseSuccess(NotifyActionTypes.GET_NOTIFY, data, message, code, false, false));
        } else {
            let msg = `An error while getting notify!`;
            if (message) msg = message;
            yield put(notifyApiResponseSuccess(NotifyActionTypes.GET_NOTIFY, data, msg, code, true, false));
        }
    } catch (error: any) {
        yield put(notifyApiResponseError(NotifyActionTypes.GET_NOTIFY, [], error, 404, true, false));
    }
}

/**
 * Fetch Notifys
 * @param {*} payload
 */
function* GetNotifys({ payload, type }: NotifyData): SagaIterator {
    try {
        const response = yield call(getAllNotifyApi, payload);
        const { data, message, success, code } = response.data;

        const responseData = typeof data === 'object' && Object.keys(data).length === 0 ? [] : data;
        if (code === 200 && success) {
            yield put(
                notifyApiResponseSuccess(NotifyActionTypes.GET_NOTIFYS, responseData, message, code, false, false)
            );
        } else {
            let msg = `An error while getting notify Listing!`;
            if (message) msg = message;
            yield put(notifyApiResponseSuccess(NotifyActionTypes.GET_NOTIFYS, responseData, msg, code, true, false));
        }
    } catch (error: any) {
        yield put(notifyApiResponseError(NotifyActionTypes.GET_NOTIFYS, [], error, 404, true, false));
    }
}

export function* watchGetNotify() {
    yield takeEvery(NotifyActionTypes.GET_NOTIFY, GetNotify);
}

export function* watchGetNotifys() {
    yield takeEvery(NotifyActionTypes.GET_NOTIFYS, GetNotifys);
}

export function* watchAddNotify() {
    yield takeEvery(NotifyActionTypes.ADD_NOTIFY, AddNotify);
}

export function* watchEditNotify(): any {
    yield takeEvery(NotifyActionTypes.EDIT_NOTIFY, EditNotify);
}

function* notifySaga() {
    yield all([fork(watchGetNotify), fork(watchAddNotify), fork(watchEditNotify), fork(watchGetNotifys)]);
}

export default notifySaga;
